import { useEffect } from "react";

/**
 * Iubenda is the official source of TIME Inside's legal documents.
 * This route is preserved (referenced by CheckoutPage and other internal links)
 * and redirects to the official Iubenda-hosted Privacy Policy.
 */
const IUBENDA_URL = "https://www.iubenda.com/privacy-policy/61078636";

export default function PrivacyPolicyPage() {
  useEffect(() => {
    window.location.replace(IUBENDA_URL);
  }, []);

  return (
    <div
      data-testid="privacy-policy-redirect"
      className="min-h-[60vh] flex items-center justify-center px-6"
    >
      <a
        href={IUBENDA_URL}
        className="text-emerald-300 hover:text-emerald-200 underline underline-offset-4 text-sm tracking-wide"
      >
        Apri la Privacy Policy ufficiale
      </a>
    </div>
  );
}
